import { ArrowLeft, Sun, Moon } from "lucide-react";
import { Card } from "@/projects/Admin_Bite_Balance/bite-balance/src/components/ui/card";
import { Button } from "@/projects/Admin_Bite_Balance/bite-balance/src/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useTheme } from "next-themes";
import { useState, useEffect } from "react";

const Preferences = () => {
  const navigate = useNavigate();
  const { theme, setTheme } = useTheme();

  const [heightUnit, setHeightUnit] = useState(
    () => localStorage.getItem("preferredHeightUnit") || "ft-inch"
  );
  const [weightUnit, setWeightUnit] = useState(
    () => localStorage.getItem("preferredWeightUnit") || "kg"
  );

  useEffect(() => {
    localStorage.setItem("preferredHeightUnit", heightUnit);
  }, [heightUnit]);

  useEffect(() => {
    localStorage.setItem("preferredWeightUnit", weightUnit);
  }, [weightUnit]);
  return (
    <div className="min-h-screen bg-background pb-24">
      <div className="mx-auto max-w-md">
        {/* Header */}
        <div className="flex items-center gap-3 border-b-2 border-border p-4">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate("/profile")}
            className="rounded-xl"
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <div>
            <h1 className="text-xl font-bold text-foreground">Preferences</h1>
            <p className="text-xs text-muted-foreground">Customize your app</p>
          </div>
        </div>

        <div className="space-y-4 p-4">
          {/* Theme Selection */}
          <Card className="rounded-2xl border-2 border-border p-5 shadow-md">
            <h3 className="mb-4 text-lg font-bold text-foreground">
              Appearance
            </h3>
            <div className="grid grid-cols-2 gap-3">
              <button
                onClick={() => setTheme("light")}
                className={`rounded-xl border-2 p-4 transition-all ${
                  theme === "light"
                    ? "border-primary bg-primary/10 shadow-md"
                    : "border-border hover:border-primary/50"
                }`}
              >
                <div className="flex flex-col items-center gap-2">
                  <Sun className="h-7 w-7" />
                  <span className="text-sm font-bold">Light Mode</span>
                </div>
              </button>
              <button
                onClick={() => setTheme("dark")}
                className={`rounded-xl border-2 p-4 transition-all ${
                  theme === "dark"
                    ? "border-primary bg-primary/10 shadow-md"
                    : "border-border hover:border-primary/50"
                }`}
              >
                <div className="flex flex-col items-center gap-2">
                  <Moon className="h-7 w-7" />
                  <span className="text-sm font-bold">Dark Mode</span>
                </div>
              </button>
            </div>
          </Card>

          {/* Language */}
          <Card className="rounded-2xl border-2 border-border p-5 shadow-md">
            <h3 className="mb-4 text-lg font-bold text-foreground">Language</h3>
            <select className="w-full rounded-lg border-2 border-border bg-background px-3 py-2 text-sm font-semibold">
              <option>English</option>
              <option>Spanish</option>
              <option>French</option>
              <option>German</option>
              <option>Hindi</option>
            </select>
          </Card>

          {/* Time Format */}
          <Card className="rounded-2xl border-2 border-border p-5 shadow-md">
            <h3 className="mb-4 text-lg font-bold text-foreground">
              Time Format
            </h3>
            <select className="w-full rounded-lg border-2 border-border bg-background px-3 py-2 text-sm font-semibold">
              <option>12-hour (AM/PM)</option>
              <option>24-hour</option>
            </select>
          </Card>

          {/* Height Unit */}
          <Card className="rounded-2xl border-2 border-border p-5 shadow-md">
            <h3 className="mb-4 text-lg font-bold text-foreground">
              Height Unit
            </h3>
            <select
              value={heightUnit}
              onChange={e => setHeightUnit(e.target.value)}
              className="w-full rounded-lg border-2 border-border bg-background px-3 py-2 text-sm font-semibold"
            >
              <option value="ft-inch">Ft-Inch</option>
              <option value="cm">Centimeters (cm)</option>
            </select>
          </Card>

          {/* Weight Unit */}
          <Card className="rounded-2xl border-2 border-border p-5 shadow-md">
            <h3 className="mb-4 text-lg font-bold text-foreground">
              Weight Unit
            </h3>
            <select
              value={weightUnit}
              onChange={e => setWeightUnit(e.target.value)}
              className="w-full rounded-lg border-2 border-border bg-background px-3 py-2 text-sm font-semibold"
            >
              <option value="kg">Kilograms (kg)</option>
              <option value="lbs">Pounds (lbs)</option>
            </select>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Preferences;
